import React from 'react'
import styles from "styles/pages/RangeInformation.module.scss";
import { Grid, Skeleton } from "@mui/material";


export default function RangeInfoSkeleton() {

  return (
    <div>
         <div className={styles.range_form}>
                    <div className={styles.formSec}>
                      <Grid container spacing={0}>
                        <Grid item md={6} xs={12}>
                          <div className={styles.formGroup}> 
                               <label>Range Name *</label>
                            <Skeleton variant="rounded"  height={40} />
                          </div>
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <div className={styles.formGroup}>
                            <label>CLASSIFICATION</label>
                            <Skeleton variant="rounded" height={40} />
                          </div>
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <div className={styles.formGroup}>
                             <label>ADDRESS 1*</label>
                            <Skeleton variant="rounded"  height={40} />
                          </div>
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <div className={styles.formGroup}>
                          <label>ADDRESS 2</label>
                          <Skeleton variant="rounded"  height={40} />
                          </div>
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <div className={styles.formGroup}>
                             <label>CITY *</label>
                            <Skeleton variant="rounded"  height={40} />
                          </div>
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <div className={styles.formGroup}>
                            <label>STATE</label>
                            <Skeleton variant="rounded"  height={40} />
                          </div>
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <div className={styles.formGroup}>
                          <label>OTHER STATE</label>
                          <Skeleton variant="rounded" height={40} />
                          </div>
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <div className={styles.formGroup}>
                          <label>ZIP CODE</label>
                          <Skeleton variant="rounded"  height={40} />
                          </div>
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <div className={styles.formGroup}>
                             <label>COUNTRY *</label>
                            <Skeleton variant="rounded"  height={40} />
                          </div>
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <div className={styles.formGroup}>
                          <label>PHONE NUMBER</label>
                          <Skeleton variant="rounded" height={40} />
                          </div>
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <div className={styles.formGroup}>
                          <label>WEBSITE</label>
                          <Skeleton variant="rounded"  height={40} />
                          </div>
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <div className={styles.formGroup}>
                            <label>STATUS</label>
                            <Skeleton variant="rounded" height={40} />
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                  </div>
    </div>
  )
}
